"use strict";

exports.__esModule = true;
var _Translator = require("./Translator");
Object.keys(_Translator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Translator[key]) return;
  exports[key] = _Translator[key];
});
var _withTranslator = require("./withTranslator");
Object.keys(_withTranslator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _withTranslator[key]) return;
  exports[key] = _withTranslator[key];
});
var _TranslatorContext = require("./TranslatorContext");
Object.keys(_TranslatorContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranslatorContext[key]) return;
  exports[key] = _TranslatorContext[key];
});
var _hashMessage = require("./hashMessage");
Object.keys(_hashMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _hashMessage[key]) return;
  exports[key] = _hashMessage[key];
});